import { VanishList } from "./components/VanishList";

function App() {
  return (
    <div>
      <VanishList />
    </div>
  );
}

export default App;
